import { render, staticRenderFns } from "./MoleculeEditionAcademyUsersProfileAccount.vue?vue&type=template&id=1d919b52&"
import script from "./MoleculeEditionAcademyUsersProfileAccount.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAcademyUsersProfileAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports